import { render, staticRenderFns } from "./card-hsia-category.vue?vue&type=template&id=5fdadf60&scoped=true&"
import script from "./card-hsia-category.vue?vue&type=script&lang=js&"
export * from "./card-hsia-category.vue?vue&type=script&lang=js&"
import style0 from "./card-hsia-category.vue?vue&type=style&index=0&id=5fdadf60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdadf60",
  null
  
)

export default component.exports